import { CHAMPIONS } from "@/game-lol/constants/champion-classes.mjs";

export function getChampionPrimaryClass(championId) {
  return CHAMPIONS[championId]?.primaryClass;
}

export function getChampionSubClass(championId) {
  return CHAMPIONS[championId]?.subClass || CHAMPIONS[championId]?.primaryClass;
}
